import User from './index';
import UserStatus from './UserStatus';
import UserSub from './UserSub';
import UserAssess from './UserAssess';
import UserCoinAddress from './UserCoinAddress';
import UserRights from './UserRights';
import UserTag from './UserTags';
import Project from './Project';
import MarketMaker from './MarketMaker';
import UserMsg from './UserMsg';
import UserWithdrawalConfig from './UserWithdrawalConfig';
import BalanceSnapshot from './balanceSnapshot';
import verification from './VerificationRecord';
import emailUser from './BindEmailUser';
import UserWithdrawCoinAddress from './UserWithdrawCoinAddress';
import emailGroup from './BindEmailGroup';
import userstatistics from "./statistics";
import statisticsPlatform from "./statisticsPlatform";
import comment from './comment';


export default {
  path: '/home/user',
  component: User,
  redirect: '/home/user/userstatus',
  children: [
    { path: '/home/user/userstatus', component: UserStatus },
    { path: '/home/user/usersub', component: UserSub },
    { path: '/home/user/assess', component: UserAssess },
    { path: '/home/user/usercoinaddress', component: UserCoinAddress },
    { path: '/home/user/right', component: UserRights },
    { path: '/home/user/tag', component: UserTag },
    { path: '/home/user/project', component: Project },
    { path: '/home/user/market/maker', component: MarketMaker },
    { path: '/home/user/userMsg/edit', component: UserMsg },
    { path: '/home/user/UserWithdrawalConfig', component: UserWithdrawalConfig },
    { path: '/home/user/balanceSnapshot', component: BalanceSnapshot },
    { path: '/home/hashrate/verification', component: verification },
    { path: '/home/user/BindEmailGroup/emailGroup', component: emailGroup },
    { path: '/home/user/BindEmailUser/emailUser', component: emailUser },
    { path: '/home/user/userstatistics', component: userstatistics },
    { path: '/home/user/statisticsPlatform', component: statisticsPlatform },
    { path: '/home/user/userWithdrawCoinAddress', component: UserWithdrawCoinAddress },
    { path: '/home/user/comment', component: comment }
  ]
};
